import React, { useState } from 'react';

import TabNav from './TabNav';
import { TabItem } from './types';

type TabContainerProps = {
  tabs: TabItem[];
};

const TabContainer: React.FC<TabContainerProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <div className=''>
      <TabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <div className='mt-6'>{tabs.find((tab) => tab.id === activeTab)?.content}</div>
    </div>
  );
};

export default TabContainer;
